import CancelIcon from "@mui/icons-material/Cancel";
import { Box, Dialog, DialogContent, Drawer, styled } from "@mui/material";
import React, { useContext } from "react";

import { Context } from "../../context/context";
import { useMobile } from "../../utils/findViewport";
import ReviewStories from "./story";

const CustomStoryDrawer = styled(Box)(() => ({ position: "relative" }));

const StoryDrawer = () => {
  const state = useContext(Context);
  const { hideReviewStoryDrawer } = useContext(Context);
  const open = state?.showReviewStoryDrawerValue;
  const mobile = useMobile();
  const deskTopView = () => {
    return (
      <Box>
        <Dialog
          open={open}
          onClose={() => {
            hideReviewStoryDrawer();
            // sendAnalytics("enquiry_ev_consult_popup_dismissed", {}, "en");
          }}
          PaperProps={{
            sx: { display: { xs: "none", md: "block" } },
          }}
        >
          <DialogContent style={{ padding: "10px", margin: "20px" }}>
            <Box
              onClick={() => {
                hideReviewStoryDrawer();
              }}
              style={{
                fontSize: "20px",
                color: "grey",
                position: "absolute",
                right: "46%",
                bottom: "4px",
                zIndex: "999",
              }}
            >
              <CancelIcon fontSize="large" />
            </Box>
            <Box>
              <ReviewStories />
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    );
  };

  const mobileView = () => {
    return (
      <Box>
        <Drawer
          anchor="bottom"
          open={open}
          onClose={() => {
            hideReviewStoryDrawer();
          }}
          onOpen={open}
          transitionDuration={1000}
          // style={{

          // }}
          sx={{
            "& .MuiDrawer-paper": {
              // position: "relative",
              overflowY: "visible",
            },
          }}
          PaperProps={{
            sx: { display: { xs: "block", sm: "none" } },
          }}
        >
          <Box
            onClick={() => {
              hideReviewStoryDrawer();
            }}
            style={{
              fontSize: "20px",
              color: "grey",
              position: "absolute",
              right: "46%",
              bottom: "4px",
              zIndex: "999",
            }}
          >
            <CancelIcon fontSize="large" />
          </Box>
          <Box>
            <ReviewStories />
          </Box>
        </Drawer>
      </Box>
    );
  };

  return (
    <CustomStoryDrawer>
      <Box>{mobile ? mobileView() : deskTopView()}</Box>
    </CustomStoryDrawer>
  );
};

export default StoryDrawer;
